/** @format */

import { API_URL } from 'src/constants';

export function prependApiUrlToCmsPaths(html?: string | null): string {
  if (!html || typeof html !== 'string') return html || '';
  if (!API_URL || typeof API_URL !== 'string') return html;

  let baseUrl = API_URL.trim();
  if (!baseUrl) return html;

  try {
    baseUrl = new URL(baseUrl).origin;
  } catch {
    baseUrl = baseUrl.replace(/\/+$/, '');
  }

  return html.replace(
    /(src|href)\s*=\s*(['"]?)(\\?\/sites\/[^'"\s>]+)\2/gi,
    (_full: string, attr: string, quote: string, path: string) => {
      const normalizedPath = String(path || '').replace(/^\\\//, '/');
      const safeQuote = quote || '"';
      return `${attr}=${safeQuote}${baseUrl}${normalizedPath}${safeQuote}`;
    }
  );
}
